import React, { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg2 from "../../Assets/avatar2.jpg";
import myImg1 from "../../Assets/avatar.jpg";
import Tilt from "react-parallax-tilt";
import { motion } from "framer-motion";

import {
  AiFillGithub,
  AiFillInstagram,
} from "react-icons/ai";

import { FaLinkedinIn } from "react-icons/fa";
import { SiLeetcode } from "react-icons/si";

function Home2() {
  const [selectedImg, setSelectedImg] = useState(myImg2);

  const handleImageClick = () => {
    setSelectedImg((prev) =>
      prev === myImg1 ? myImg2 : myImg1
    );
  };

  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row className="align-items-center">
          {/* LEFT SIDE */}
          <Col md={8} className="home-about-description">
            <motion.h1
              initial={{ opacity: 0, x: -80 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 1 }}
              viewport={{ once: true }}
              style={{
                fontSize: "2.5rem",
                fontWeight: "700",
              }}
            >
              LET ME{" "}
              <span className="purple">
                INTRODUCE
              </span>{" "}
              MYSELF
            </motion.h1>

            <motion.p
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              transition={{ duration: 1.2 }}
              viewport={{ once: true }}
              className="home-about-body"
              style={{
                fontSize: "1.08rem",
                lineHeight: "1.8",
                textAlign: "justify",
              }}
            >
              I am a passionate{" "}
              <b className="purple">
                Software Engineer and Full Stack Developer
              </b>{" "}
              with a strong interest in designing scalable,
              secure, and high-performance enterprise
              applications. I enjoy solving complex
              engineering problems and building
              production-ready software systems that
              deliver real-world business value.

              <br />
              <br />

              Throughout my academic journey and project
              experience, I have developed practical
              expertise in{" "}
              <b className="purple">
                ASP.NET Core, React.js, Microservices,
                REST APIs, SQL Server, Redis, RabbitMQ,
                Docker, Git, and Cloud technologies
              </b>
              . My programming foundation includes{" "}
              <b className="purple">
                C++, C#, JavaScript, Java, and SQL
              </b>
              , while I continuously strengthen my
              knowledge in software architecture,
              distributed systems, backend engineering,
              DevOps practices, and system design.

              <br />
              <br />

              My long-term goal is to become a highly
              skilled{" "}
              <b className="purple">
                Software Architect and Cloud-Native
                Engineer
              </b>
              , specializing in enterprise software
              development, scalable distributed
              architectures, cloud computing, and
              modern engineering practices to build
              impactful, large-scale software solutions.
            </motion.p>
          </Col>

          {/* RIGHT SIDE */}
          <Col
            md={4}
            className="myAvtar"
            style={{
              textAlign: "center",
              paddingTop: "30px",
            }}
          >
            <motion.div
              initial={{ scale: 0 }}
              whileInView={{ scale: 1 }}
              transition={{ duration: 1 }}
              viewport={{ once: true }}
              style={{
                color: "#c770f0",
                fontWeight: "600",
                marginBottom: "15px",
                fontSize: "17px",
              }}
            >
              📸 Click image to switch profile
            </motion.div>

            <Tilt
              tiltMaxAngleX={10}
              tiltMaxAngleY={10}
              perspective={1000}
              transitionSpeed={1500}
              scale={1.03}
            >
              <motion.img
                whileHover={{
                  scale: 1.05,
                }}
                whileTap={{
                  scale: 0.95,
                }}
                src={selectedImg}
                alt="avatar"
                className="img-fluid"
                onClick={handleImageClick}
                style={{
                  borderRadius: "20px",
                  cursor: "pointer",
                  maxWidth: "360px",
                  maxHeight: "420px",
                  boxShadow:
                    "0 0 30px rgba(199,112,240,0.35)",
                }}
              />
            </Tilt>
          </Col>
        </Row>

        {/* SOCIAL SECTION */}
        <Row>
          <Col md={12} className="home-about-social">
            <motion.h1
              initial={{ opacity: 0, y: 40 }}
              whileInView={{
                opacity: 1,
                y: 0,
              }}
              transition={{
                duration: 1,
              }}
              viewport={{ once: true }}
            >
              CONNECT WITH ME
            </motion.h1>

            <motion.p
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              transition={{
                duration: 1.5,
              }}
              viewport={{ once: true }}
            >
              Feel free to{" "}
              <span className="purple">
                connect, collaborate, or discuss
                software engineering and technology
              </span>
            </motion.p>

            <motion.ul
              className="home-about-social-links"
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              transition={{
                duration: 2,
              }}
              viewport={{ once: true }}
            >
              <li className="social-icons">
                <motion.a
                  whileHover={{
                    scale: 1.2,
                  }}
                  href="https://github.com/gauravjha0711"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <AiFillGithub />
                </motion.a>
              </li>

              <li className="social-icons">
                <motion.a
                  whileHover={{
                    scale: 1.2,
                  }}
                  href="https://leetcode.com/u/gauravjha0711/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <SiLeetcode
                    size={28}
                    color="#FFA116"
                  />
                </motion.a>
              </li>

              <li className="social-icons">
                <motion.a
                  whileHover={{
                    scale: 1.2,
                  }}
                  href="https://www.linkedin.com/in/gaurav-kumar-729503265/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <FaLinkedinIn />
                </motion.a>
              </li>

              <li className="social-icons">
                <motion.a
                  whileHover={{
                    scale: 1.2,
                  }}
                  href="https://www.instagram.com/gauravjhagk"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <AiFillInstagram />
                </motion.a>
              </li>
            </motion.ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Home2;